var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"calc(100% - 60px)"},attrs:{"id":"boxW"}},[_c('canvas',{attrs:{"width":_vm.width,"height":_vm.width,"id":"canvas"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }